module.exports = __webpack_public_path__ + "img/logo4.017be523.png";